import { Edit, GroupAdd, History, Settings } from '@mui/icons-material';
import { Stack, Tooltip, IconButton } from '@mui/material';

import { useWorkspaceContext } from '../../../context';
import { TeamAccessAction, useTeamAccessAuthz } from '../../../hooks/useTeamAccessAuthz';
export interface ITeamListActionsProps {
  navigateToMembersPage: () => void;
  openTeamNameEdit: () => void;
  openTeamSettings: () => void;
  openHistory: () => void;
}

const TeamListActions = ({
  navigateToMembersPage,
  openTeamNameEdit,
  openTeamSettings,
  openHistory,
}: ITeamListActionsProps) => {
  const admin = useWorkspaceContext();

  const { access: teamAccessControl } = useTeamAccessAuthz([TeamAccessAction.MANAGE_TEAMS_ACCESS]);

  const manageAccess = admin.owns || teamAccessControl[0];

  return (
    <Stack direction="row">
      {manageAccess && (
        <Tooltip title="Add members">
          <IconButton>
            <GroupAdd onClick={() => navigateToMembersPage()} />
          </IconButton>
        </Tooltip>
      )}
      {manageAccess && (
        <Tooltip title="Edit team name">
          <IconButton>
            <Edit cursor="pointer" onClick={openTeamNameEdit} />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="Settings">
        <IconButton>
          <Settings cursor="pointer" onClick={openTeamSettings} />
        </IconButton>
      </Tooltip>
      <Tooltip title="See team history">
        <IconButton>
          <History cursor="pointer" onClick={openHistory} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default TeamListActions;
